export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = ["en", "bg"];
export const LANGUAGE_STORAGE_KEY = "warenex-language";

export const isSupportedLanguage = (language) =>
  SUPPORTED_LANGUAGES.includes(language);

export const detectBrowserLanguage = (languages) => {
  const primaryLanguage = Array.isArray(languages) ? languages[0] : languages;
  const languageCode = String(primaryLanguage || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];

  return languageCode === "bg" ? "bg" : DEFAULT_LANGUAGE;
};

export const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  try {
    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (isSupportedLanguage(storedLanguage)) {
      return storedLanguage;
    }
  } catch {
    // Browser privacy settings can make localStorage unavailable.
  }

  const browserLanguages = window.navigator.languages?.length
    ? window.navigator.languages
    : window.navigator.language;

  return detectBrowserLanguage(browserLanguages);
};
